import { useState } from "react";
import { requestPost } from "shared-utils";

import { connectByPath } from "../services";
import { prepFormData } from "../transformers";

/**
 * To encapsulate the logic for handling the initial connection request from the create connection modal
 */
export const useConnectByPost = (
  errorHandler
): [
  (path: string, connectorSlug: string, formData: any) => Promise<void>,
  { [key: string]: { [key: string]: string } }
] => {
  const [serverValidationErrors, setServerValidationErrors] = useState({});

  /**
   * Init oauth by posting form data from the connection modal
   */
  const connectByPost = async (path: string, connectorSlug: string, formData: any) => {
    try {
      // Clear previous server errors for this connector before the new request
      setServerValidationErrors((messages) => {
        const next = { ...messages };
        delete next[connectorSlug];
        return next;
      });
      const response = await requestPost(path, prepFormData(connectorSlug, formData));

      // error
      if ("errorMessage" in response) {
        setServerValidationErrors((messages) => ({ ...messages, [connectorSlug]: response }));
      }
      // success
      if ("authUrl" in response) {
        await connectByPath(response.authUrl);
      }
    } catch (e) {
      errorHandler(e);
    }
  };

  return [connectByPost, serverValidationErrors];
};
